<script>
  import { slide } from 'svelte/transition'
  import { user } from '../../models/user.js'
  import Alert from '../../components/Alert.svelte'
  import { onMount } from 'svelte'

  onMount(() => {
    if ($user && $user.username !== null) {
      user.logout()
    }
  })
</script>

<style type="text/less">
  .container {
    padding: var(--spacing-sm);
  }
  @media (min-width: 800px) {
    .container {
      padding: var(--spacing);
    }
  }
</style>

<div class="container">
  <div class="user-cont" transition:slide>
    <div class="user-content">
      <h1 class="user-title">Signed Out</h1>
      <div class="user-form">

        <Alert type="accent-2" icon="info">
          You have been signed out of your account.
        </Alert>

        <p class="text-right">
          <a href="/login?referrer={window.location.pathname}">
            Sign back in
            <svg class="icon">
              <use href="/icons.svg#keyboard_arrow_right" />
            </svg>
          </a>

          <a href="/" rel="external">
            Return to site
            <svg class="icon">
              <use href="/icons.svg#keyboard_arrow_right" />
            </svg>
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
